// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__XYgy-","secondary":"Button_secondary__QwN49","icon":"Button_icon__KeIH3","bounce-right":"Button_bounce-right__rNwLN"};